import { AutogenLayoutExciseTaxHistoryList } from "./autogen/AutogenLayoutExciseTaxHistoryList";
import { LookupModelSearchEvent, TableRow, ClickEvent } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { OrderTabView } from "@mcleod/dispatch";
import { MiscInvoiceHistory } from "./MiscInvoiceHistory";

export class ExciseTaxHistoryList extends AutogenLayoutExciseTaxHistoryList {
    onLoad(): void | Promise<void> {
        this.sourceExcisetaxHistory.orderBy = [{ field: "post_date", sort: "desc" }];
        this.sourceExcisetaxHistory.search(null, null, this.layoutName);
        this.tableExciseTaxHistory.rowProps = {
            onDblClick: (event) => this.tableRowOnDblClick(event)
        };
    }

    textboxStateIdProvinceBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.country_id = "in CAN,CAD";
    }

    tableRowOnDblClick(event: ClickEvent) {
        const tableRow = event.target as TableRow;
        const modelRow = tableRow.data as ModelRow;
        if (modelRow.get("parent_row_type") === "M") {
            MiscInvoiceHistory.slideUp({invoiceNoString: modelRow.get("invoice_no_string")});
        }
        else {
            OrderTabView.slideUp({key: tableRow.data.get("order_id"), additionalProps: {startOnInvoiceHistory: true}});
        }
    }
}
